import { useI18n } from "../../i18n/useI18n";
import styles from '../../users/styles/users.module.scss';

export const CompaniesTableHeader = () => {
  const { t } = useI18n();

  return (
    <div className={styles["headertableusers"]}>
      <div className={styles["headertableusers__head"]}>
        {t("companies_module.table_header_item1")}
      </div>
      <div className={styles["headertableusers__head"]}>
        {t("companies_module.table_header_actions")}
      </div>
    </div>
  )
}
